let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggiaN")).then(() => parcelRequire('6DxKg'));